import { useEffect, useState } from 'react';
import { useGetQueriesQuery } from 'src/services/Queries';
import { setProgress } from 'src/store/Loader';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { ContextMenu, QueryKeys } from 'src/types/Queries';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { checkListQueries } from './checklistQueriesData';

export const useQueryMenus = (applicationmoduleSection: any) => {
  const { selectedAppSection } = useSelectedAppInfo();
  const [contextMenu, setContextMenu] = useState<ContextMenu | null>(null);
  const [raisedQueries, setRaisedQueries] = useState<string[]>([]);
  const [raisedSectionQueries, setRaisedSectionQueries] = useState<string[]>([]);
  const [latestSecQueryRaisedBy, setlatestSecQueryRaisedBy] = useState<any>();
  const [totalFieldQueries, setTotalFieldQueries] = useState(0);
  const [totalSectionQueries, setTotalSectionQueries] = useState(0);
  const [queryType, setQueryType] = useState('');
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const [report_id, setReport_id] = useState<string>();
  const [queryKeys, setQueryKeys] = useState<QueryKeys>({
    report_section_name: '',
    report_field_name: '',
    report_field_label: '',
    report_field_value: '',
    is_all_field_queries: false,
    id: null
  });

  const [fieldQueries, setfieldQueries] = useState<any>(null);
  const dispatch = useAppDispatch();

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);

  const {
    isLoading,
    data: fieldQueriesData,
    isError,
    isSuccess,
    refetch
  } = useGetQueriesQuery({
    site_id: selectedSite == null ? '' : selectedSite,
    study_id: studyId,
    country: selectedCountry == null ? '' : selectedCountry,
    application: process.env.REACT_APP_NAME,
    application_section: selectedAppSection,
    application_module_section: applicationmoduleSection
  });

  useEffect(() => {
    dispatch(setProgress(isLoading));
  }, [isLoading]);
  const getSivReportQueries = () => {
    refetch();
  };

  useEffect(() => {
    getSivReportQueries();
  }, [selectedSite]);
  const risedQueryArr: string[] = [];
  useEffect(() => {
    let countFieldQueries = 0;
    let countSectionQueries = 0;

    const risedSectionQueryArr: string[] = [];
    let secQueryRaisedBy: any = {};
    if (fieldQueries != null) {
      const test: any = fieldQueries;
      test.map((queryObj: any) => {
        if (queryObj.query.report_query_type == 'Field' && queryObj.query.report_is_opened) {
          risedQueryArr.push(queryObj.query.report_field_name);
          if (
            queryKeys.is_all_field_queries === true &&
            queryType != 'Field' &&
            queryObj.query.report_section_name == queryKeys.report_section_name &&
            queryKeys.section_field_names?.includes(queryObj.query.report_field_name)
          ) {
            countFieldQueries = countFieldQueries + 1;
          } else if (
            (queryObj.query.report_section_name == 'MileStone' && queryObj.query.report_id == queryKeys.id) ||
            (queryObj.query.report_section_name !== 'MileStone' &&
              queryObj.query.report_section_name == queryKeys.report_section_name &&
              queryObj.query.report_field_name == queryKeys.report_field_name)
          ) {
            countFieldQueries = countFieldQueries + 1;
          }
        } else if (queryObj.query.report_query_type == 'Field' && !queryObj.query.report_is_opened) {
          if (
            queryKeys.is_all_field_queries === true &&
            queryObj.query.report_section_name == queryKeys.report_section_name &&
            queryKeys.section_field_names?.includes(queryObj.query.report_field_name)
          ) {
            countFieldQueries = countFieldQueries + 1;
          } else if (
            queryObj.query.report_section_name == queryKeys.report_section_name &&
            queryObj.query.report_field_name == queryKeys.report_field_name
          ) {
            countFieldQueries = countFieldQueries + 1;
          }
        } else {
          if (
            queryObj.query.report_query_type == 'Section' &&
            queryObj.query.report_section_name == queryKeys.report_section_name
          ) {
            countSectionQueries = countSectionQueries + 1;
          }
        }
        if (queryObj.query.report_query_type == 'Section' && queryObj.query.report_is_opened) {
          risedSectionQueryArr.push(queryObj.query.report_section_name);
          const queryCreator = queryObj.query.created_by.split(' ');
          let queryCreatedBy = '';
          if (queryCreator.length > 1) {
            queryCreatedBy = `${queryCreator[1]} ${queryCreator[0]}`;
          } else {
            queryCreatedBy = [...queryCreator].toString();
          }
          secQueryRaisedBy = {
            ...secQueryRaisedBy,
            [queryObj.query.report_section_name]: queryCreatedBy
          };
        }
      });
    }
    setlatestSecQueryRaisedBy(secQueryRaisedBy);
    setRaisedQueries(risedQueryArr);
    setRaisedSectionQueries(risedSectionQueryArr);
    setTotalFieldQueries(countFieldQueries);
    setTotalSectionQueries(countSectionQueries);
  }, [queryKeys, fieldQueries, queryType]);

  useEffect(() => {
    if (fieldQueriesData && !isError && isSuccess && !isLoading) {
      setfieldQueries(fieldQueriesData);
    } else {
      setfieldQueries(null);
    }
  }, [fieldQueriesData, isError, isSuccess, isLoading]);
  // useEffect(() => {
  //   if(risedQueryArr)
  //   {
  //     setRaisedQueries(risedQueryArr);
  //   }
  // }, [risedQueryArr]);

  return {
    contextMenu,
    setContextMenu,
    queryKeys,
    setQueryKeys,
    checkListQueries,
    raisedQueries,
    setRaisedQueries,
    fieldQueries,
    totalFieldQueries,
    totalSectionQueries,
    getSivReportQueries,
    raisedSectionQueries,
    report_id,
    setReport_id,
    queryType,
    setQueryType,
    latestSecQueryRaisedBy
  };
};
